__turbopack_context__.v({
  "grid": "NumberWidgetsList-module__LAiLBW__grid",
});
